module.exports = __webpack_public_path__ + "img/pile-online.5bceb48b.png";